export function valueOrDefault(value, defValue) {
    if (typeof value === "undefined" || value === null) {
        return defValue;
    }
    else {
        return value;
    }
}
//# sourceMappingURL=valueOrDefault.js.map